var React = require('react');

function PaymentInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zM1 4v2h14V4H1zm10 7v1h3v-1h-3z","fill":"currentColor","fillRule":"evenodd"}));
}

PaymentInline.defaultProps = {"viewBox":"0 0 16 16"};

module.exports = PaymentInline;

PaymentInline.default = PaymentInline;
